import React, { useContext } from "react";
import "./Plan_Purchase_content_header.css";
import { Link, useNavigate } from "react-router-dom";
import Dwounload_lottie from "./Dwounload_lottie/Dwounload_lottie";
import Gray_btn from "../../../Common_Component/Common_Btn/Gray_btn/Gray_btn";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import Know_Your_Plan from "../../../Common_Component/Common_Modal/Know_Your_Plan/Know_Your_Plan";
import { Context } from "../../../../utils/context";
function Plan_Purchase_content_header({
  val,
  hideActionLinks,
  setActiveStepIndex,
}) {
  const [modalShow, setModalShow] = React.useState(false);
  const { IMG_URL } = useContext(Context);

  const handleDownload = () => {
    const brochureUrl = `${IMG_URL}${val?.brochure}`;
    window.open(brochureUrl, "_blank");
  };
  return (
    <>
      <section className="plan-purchase-header">
        <div className="plan-header-container">
          <div className="main_logo_holder">
            <div className="logo-container">
              <img
                src={`${IMG_URL}${val?.image}`}
                alt="Bajaj Allianz Logo"
                className="company-logo"
              />
            </div>
          </div>
          <div className="header_holder">
            <div className="plan-title">
              <h3>{val?.name}</h3>
            </div>

            {/* Hide action links when hideActionLinks is true */}
            {!hideActionLinks && (
              <div className="action-links">
                <div className="plan-link" onClick={() => setModalShow(true)}>
                  <span>Know Your Plan!</span>
                </div>
                <div onClick={handleDownload} className="download-brochure">
                  {/* <Link to={"/"} className="download-brochure"> */}
                  <Dwounload_lottie />
                  <span>Download Brochure</span>
                  {/* </Link> */}
                </div>
              </div>
            )}
            {hideActionLinks && (
              <div
                className="edit_btn_holder"
                onClick={() => {
                  setActiveStepIndex(0);
                }}
              >
                <Gray_btn lefticon={faPenToSquare} btn_name="Edit" />
              </div>
            )}
          </div>
        </div>
      </section>

      <Know_Your_Plan
        val={val}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default Plan_Purchase_content_header;
